<script setup>
// §8.7 WidgetEmptyState — an empty widget is a GOOD outcome ("nothing needs
// you"), so it must NOT read as a failure (§8.7, §9). Quieter and calmer than a
// full-page EmptyState: a check glyph, a reassuring line, no alarm.
import LIcon from '../base/Icon.vue'
defineProps({
  message: { type: String, default: 'Nothing needs you here.' },
})
</script>

<template>
  <div class="l-widget-empty">
    <div class="badge" aria-hidden="true"><LIcon name="check" :size="16" /></div>
    <p class="msg">{{ message }}</p>
    <div v-if="$slots.default" class="extra"><slot /></div>
  </div>
</template>

<style scoped>
.l-widget-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: var(--sp-2);
  padding: var(--sp-6) var(--sp-4);
  min-height: 120px;
}
.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: var(--status-approved-fill);
  color: var(--status-approved-text);
}
.msg {
  font-size: var(--text-sm);
  color: var(--text-3);
}
</style>
